import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { API } from "aws-amplify";
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from "react";
import { LoadingSpinner } from "../../../../utils/LoadingSpinner";
import NotificationTemplateContent from "./NotificationTemplateContent";

interface IProps {
  notificationTemplate?: any[];
}

interface IState {
  dashboardTemplate: string;
  emailTemplate: string;
  notificationTemplate: any[];
  selectValue: string;
  showing: boolean;
  smsTemplate: string;
}

interface INotificationOption {
  label: string;
  value: string;
}

class NotificationTemplateDropDown extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      dashboardTemplate: "",
      emailTemplate: "",
      notificationTemplate: [],
      selectValue: "",
      showing: true,
      smsTemplate: "",
    };
  }

  public handleAutocompleteChange = (
    event: any,
    newValue: INotificationOption | null
  ) => {
    if (newValue) {
      const apiName = "ApaqPortalAPI";
      const path = "/notification/get-notification-template/" + newValue.value;

      this.setState({ selectValue: newValue.value });

      API.get(apiName, path, {})
        .then((value: any) => {
          this.setState({
            dashboardTemplate: value.dashboardTemplate.dashboard,
          });
          this.setState({ smsTemplate: value.smsTemplate });
          this.setState({ emailTemplate: value.emailTemplate.email });
          this.setState({ showing: false });

          console.log(value);
        })
        .catch((error) => {
          console.error(error);
          alert("Exception occurred when getting a notification template.");
        });
    }
  };

  public render() {
    // @ts-ignore
    const showLoadingSpinner = this.props.notificationTemplate.length === 0;

    const INotificationOptions: INotificationOption[] = this.props
      .notificationTemplate
      ? this.props.notificationTemplate.sort().map((template: any) => ({
          label: template.label || template,
          value: template.value || template,
        }))
      : [];

    return (
      <div>
        <div>
          <div>
            <h5> Notification Template </h5>
            {showLoadingSpinner && <LoadingSpinner />}
            <Autocomplete
              id="notification-template-autocomplete"
              options={INotificationOptions}
              getOptionLabel={(option) => option.label}
              style={{ width: 592 }}
              classes={{
                root: "MuiFormControl-root",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Notification Template"
                  variant="outlined"
                  placeholder="Start typing to filter..."
                />
              )}
              onChange={this.handleAutocompleteChange}
              filterOptions={(optionsList, { inputValue }) => {
                const filterValue = inputValue.toLowerCase();
                return optionsList.filter((option) =>
                  option.label.toLowerCase().includes(filterValue)
                );
              }}
            />
          </div>

          <div style={{ display: this.state.showing ? "none" : "block" }}>
            <NotificationTemplateContent
              data={this.state.dashboardTemplate}
              templateName={"Dashboard Notification Template"}
            />
            <NotificationTemplateContent
              data={this.state.smsTemplate}
              templateName={"Sms Notification Template"}
            />
            <NotificationTemplateContent
              data={this.state.emailTemplate}
              templateName={"Email Notification Template"}
            />
          </div>
        </div>
      </div>
    );
  }

  public getState() {
    return this.state;
  }
}

export default NotificationTemplateDropDown;
